import React from 'react';
import '../styles/Home.css';
import { Link } from 'react-router-dom';
import { marked } from 'marked';

const Home = () => {
  return (
    <div className='home-container'>
      <div className="title-bar">
        <h1 className="title">Research Assistant</h1>
        <h2 className="subtitle">Powered with AI!</h2>
      </div>
      <div className="button-container">
        <div className="button-row">
          <Link to="/research">
            <div className="card card1">
              <div className="card-inner">
                <div className="card-front">
                  <div className="card-front-title">
                    <span>Problem Analysis</span>
                    <img  src="https://rfc-info.s3.eu-north-1.amazonaws.com/Problem_Analysis.png" alt="RFC Problem Analysis" className="card-icon" />
                  </div>
                  <p className="card-front-description">Get help with gathering and analyzing research data.</p>
                </div>
                <div className="card-back card1">
                  <p className="card-back-title">Click here to go to the Research Analysis Assistant</p>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/root">
            <div className="card card2">
              <div className="card-inner">
                <div className="card-front">
                  <div className="card-front-title">
                    <span>Root Cause Analysis</span>
                    <img  src="https://rfc-info.s3.eu-north-1.amazonaws.com/Root_Cause_Analysis.png " alt="RFC Root Analysis" className="card-icon2" />
                  </div>
                  <p className="card-front-description">Identify and analyze the root causes of issues.</p>
                </div>
                <div className="card-back card2">
                  <p className="card-back-title">Click here to go to the Root Cause Analysis Assistant</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="button-row">
          <Link to="/consequences">
            <div className="card card3">
              <div className="card-inner">
                <div className="card-front">
                  <div className="card-front-title">
                    <span>Consequence Tracking</span>
                    <img  src="https://rfc-info.s3.eu-north-1.amazonaws.com/Consequence_Tracking.png" alt="RFC Root Analysis" className="card-icon2" />
                  </div>
                  <p className="card-front-description">Monitor and track the consequences of social problems.</p>
                </div>
                <div className="card-back card3">
                  <p className="card-back-title">Click here to go to the Consequence Tracking Assistant</p>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/interview">
            <div className="card card4">
              <div className="card-inner">
                <div className="card-front">
                  <div className="card-front-title">
                    <span>Interview Scripter</span>
                    <img  src="https://rfc-info.s3.eu-north-1.amazonaws.com/Interview_Scripter.png" alt="RFC Root Analysis" className="card-icon2" />
                  </div>
                  <p className="card-front-description">Create and manage interview scripts efficiently.</p>
                </div>
                <div className="card-back card4">
                  <p className="card-back-title">Click here to go to the Interview Scripter Assistant </p>
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="button-row">
          <Link to="/survey">
            <div className="card card5">
              <div className="card-inner">
                <div className="card-front">
                  <div className="card-front-title">
                    <span>Survey Generator</span>
                    <img  src="https://rfc-info.s3.eu-north-1.amazonaws.com/Survey Generator.png" alt="RFC Problem Analysis" className="card-icon" />
                  </div>
                  <p className="card-front-description">Receive help on how to collect your own data via a survey.</p>
                </div>
                <div className="card-back card5">
                  <p className="card-back-title">Click here to go to the Survey Generator</p>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/about">
            <div className="card card6">
              <div className="card-inner">
                <div className="card-front">
                  <div className="card-front-title">
                    <span>About</span>
                    <img  src="https://rfc-info.s3.eu-north-1.amazonaws.com/About.png " alt="RFC Root Analysis" className="card-icon2" />
                  </div>
                  <p className="card-front-description">A brief description of the application.</p>
                </div>
                <div className="card-back card6">
                  <p className="card-back-title">Click here to go to the About Page</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className="about-section">
        {/* <Link to="/about">
          <button className="button-about">About</button>
        </Link> */}
        <img src="https://rfc-info.s3.eu-north-1.amazonaws.com/rfc_pink.png" alt="RFC Info" class="small-image" />
      </div>
    </div>
  );
}

export default Home;